module.exports = __webpack_public_path__ + "static/media/03_07_02.bcca51ce.png";